import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8892b27c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "p-text-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: "p-m-2",
    style: {"width":"130px","padding":"0px","text-align":"center"},
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('editDisplay')))
  }, {
    content: _withCtx(() => [
      (_ctx.has_image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.asset_str,
            style: {"height":"50px"}
          }, null, 8, _hoisted_1))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.asset_str), 1))
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.name), 1)
    ]),
    _: 1
  }))
}